export default "__VITE_ASSET__COtb2r1X__"